export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10233.3e194195.jpg";